"use strict";
// These types represent users in Slack Calls, which is an API for showing 3rd party calls within the Slack client.
// More information on the API guide for Calls: https://docs.slack.dev/apis/web-api/using-the-calls-api
// and on User objects for use with Calls: https://docs.slack.dev/apis/web-api/using-the-calls-api
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=calls.js.map